import { useEffect, useRef } from 'react';
import { useFlagsService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import { useFormState } from '../../controllers';
import { messages } from './messages';

export const SuccessFlags = () => {
	const { formatMessage } = useIntl();
	const { showFlag } = useFlagsService();
	const [{ savingInProgress }] = useFormState();

	const prevRef = useRef(savingInProgress);

	useEffect(() => {
		if (!savingInProgress && prevRef.current) {
			showFlag({ type: 'success', title: formatMessage(messages.success) });
		}

		prevRef.current = savingInProgress;
	}, [formatMessage, savingInProgress, showFlag]);
	return null;
};
